import { restClient } from 'config/store/configureStore';
import { DEALERS_FILTER_URL, DEALERS_NAME_CHECK_URL, DEALERS_URL, DEALERS_API_URL, USERS_URL } from 'constants/ApiConstants';

import { resolveLink } from '../UrlResolver';

export default {
  getDealers: (link, parameters) => {
    const filterUrl = DEALERS_FILTER_URL;
    const { url, params } = resolveLink(link, filterUrl, parameters);
    return restClient.get(url, { params });
  },

  getDealer: (dealerId, params) => restClient.get(`${DEALERS_API_URL}/${dealerId}`, { params }),

  updateDealer: dealer => restClient.put(`${DEALERS_API_URL}/${dealer.id}`, dealer),

  getDealersForSelect: (link, parameters = {}) => {
    const filterUrl = DEALERS_FILTER_URL;
    const { url, params } = resolveLink(link, filterUrl, parameters);
    return restClient.get(url, { params });
  },

  getDealerForSelect: dealerId => {
    const params = { fields: 'id,name' };
    return restClient.get(`${DEALERS_URL}/${dealerId}`, { params });
  },

  getUserDealersForSelect: userId => {
    const params = { fields: 'id,name' };
    return restClient.get(`${USERS_URL}/${userId}/dealers`, { params });
  },

  getDealerTarget: dealerId => {
    const params = { projection: 'page', fields: 'targets' };
    return restClient.get(`${DEALERS_URL}/${dealerId}`, { params });
  },

  createDealer: dealer => restClient.post(DEALERS_API_URL, dealer),

  changeDealerStatus: (id, status) => restClient.patch(`${DEALERS_API_URL}/${id}/status`, { status }),

  checkDealerExist: name => {
    const params = { name };
    return restClient.head(DEALERS_NAME_CHECK_URL, { params });
  },

  uploadMedia: (dealerId, messageType, media, ext) =>
    restClient.post(
      `${DEALERS_API_URL}/${dealerId}/config/keyDeposit/customMessage/${messageType}/medias?extension=${ext}`,
      media
    ),

  fetchUploadedMedia: (dealerId, messageType, mediaId) =>
    restClient.get(`${DEALERS_API_URL}/${dealerId}/config/keyDeposit/customMessage/${messageType}/medias/${mediaId}`),

  deleteMedia: (dealerId, messageType, mediaId) =>
    restClient.delete(
      `${DEALERS_API_URL}/${dealerId}/config/keyDeposit/customMessage/${messageType}/medias/${mediaId}`
    ),
};
